import { GraduationCapIcon } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

export const WithMajorStudentCard = ({ majors }: { majors: string[] }) => {
  const { t } = useTranslation();
  return (
    <>
      <p className="flex max-w-full items-center gap-1 truncate text-xs font-normal text-muted-foreground">
        <GraduationCapIcon className="h-4 w-4 flex-shrink-0" />
        <span className="truncate">
          {majors && majors.length > 0
            ? majors.join(", ")
            : t("studentCarousel.noMajors")}
        </span>
      </p>
    </>
  );
};
